module.exports = __webpack_public_path__ + "img/icon_4_41.b622cdca.png";